import React, { useEffect, useState } from "react";
import "./AssetManagement.css";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import emtyfolder from "Media/empty-folder.webp";
import { useNavigate } from "react-router-dom";
import {
  deleteAssets,
  getAssets,
  getSharedAssets,
  getUserDetails,
  getAllSubscriptions,
  getClassificationList,
  getLocationData,
} from "Config/API/get";
import { servicePageTypeAction } from "Redux/action/render.action";
import PurchaseSubscription from "Components/Popup/PurchaseSubscription/PurchaseSubscription";
import { purchaseSubscriptionMessages } from "Constants/Values";
import { purchaseSubscription } from "Config/API/action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { assetuniqueid } from "Redux/action/variable.action";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import options from "Media/icons/feather-more-vertical.svg";
import { FormControl, IconButton, InputLabel, Select } from "@mui/material";
import PremiumIcon from "Media/premium@2x.png";
import RenderConfirm from "Components/Popup/Confirm/Container/RenderConfirm";
import AiAssistant from "Components/Assetchatbot/AiAssistant";
import AiModel from "Components/Assetchatbot/AiModel";

const DONE_TYPING_INTERVAL = 300;
const MAX_CELL_TEXT_LENGTH = 10;
const ALL_FILTER_VALUE = " ";

const MY_ASSETS_HEADERS = [
  "ASSETS#",
  "ASSET NAME",
  "CLASSIFICATION",
  "LOCATION",
  "VENDOR NAME",
];
const SHARED_ASSETS_HEADERS = [
  "ASSETS#",
  "ASSET NAME",
  "LOCATION",
  "VENDOR NAME",
];

const FILTER_SX = {
  width: { xs: 100, sm: 120, md: 140 }, // Responsive width
  "& .MuiSelect-select": {
    fontSize: { xs: "12px", sm: "13px", md: "14px" }, // text size
    padding: { xs: "6px 8px", sm: "7px 10px" },
  },
  "& .MuiInputLabel-root": {
    fontSize: { xs: "12px", sm: "13px", md: "14px" },
  },
};
const FILTER_MENU_PROPS = {
  PaperProps: { style: { maxHeight: 150, maxWidth: 140 } },
};

const byNewestFirst = (a, b) => new Date(b.createdAt) - new Date(a.createdAt);

// Shortens long cell values to keep the table tidy
const truncate = (text) =>
  text
    ? text.length > MAX_CELL_TEXT_LENGTH
      ? text.slice(0, MAX_CELL_TEXT_LENGTH) + "..."
      : text
    : "";

const FilterSelect = ({
  label,
  value,
  onChange,
  allLabel,
  items,
  getKey,
  getValue,
  getLabel,
}) => (
  <FormControl size="small" sx={FILTER_SX}>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value}
      label={label}
      onChange={(e) => onChange(e.target.value)}
      MenuProps={FILTER_MENU_PROPS}
    >
      <MenuItem value={ALL_FILTER_VALUE}>{allLabel}</MenuItem>
      {items?.map((item) => (
        <MenuItem key={getKey(item)} value={getValue(item)}>
          {getLabel(item)}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

const EmptyAssets = () => (
  <div className="empty-assets-container">
    <img src={emtyfolder} alt="empty-folder" />
    <p className="empty-assets">Currently Empty</p>
  </div>
);

const AssetManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();
  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );

  const [confirmPopup, setConfirmPopup] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [MyAssets, setMyAssets] = useState([]);
  const [SharedAssets, setSharedAssets] = useState([]);
  const [typingTimer, setTypingTimer] = useState(null);
  const [assetUserRole, setAssetUserRole] = useState("");
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [serviceTicketSubscription, setServiceTicketSubscription] = useState(
    []
  );
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [showPurchasePopup, setShowPurchasePopup] = useState(false);
  const [purchaseType, setPurchaseType] = useState("");
  const [Openaiassestantmodel, setOpenaiassestantmodel] = useState(false);
  const [newaimodel, setNewaimodel] = useState(false);
  const [classifications, setClassifications] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [selectedClassification, setSelectedClassification] =
    useState(ALL_FILTER_VALUE);
  const [selectedLocation, setSelectedLocation] = useState(ALL_FILTER_VALUE);

  const subscriptionStatus =
    serviceTicketSubscription?.subscriptionStatus?.toString();
  const isSubscribed = subscriptionStatus === "true";
  const isNotSubscribed = subscriptionStatus === "false";
  const isSuperAdmin = loggedInUserDetails?.role === "super_admin";

  useEffect(() => {
    getuserData();
    getAllAvailableSubscriptions();
    getMyAssets();
    getSharedAsset();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      getMyAssets();
      getSharedAsset();
    }, DONE_TYPING_INTERVAL);

    clearTimeout(typingTimer);
    setTypingTimer(timer);

    // Cleanup on unmount
    return () => {
      clearTimeout(typingTimer);
    };
  }, [searchKeyword]);

  useEffect(() => {
    fetchClassification();
    getAllLocations();
  }, []);

  useEffect(() => {
    getMyAssets();
  }, [selectedClassification, selectedLocation]);

  const getAllAvailableSubscriptions = () => {
    setLoader();
    getAllSubscriptions(token).then((res) => {
      resetLoader();
      if (res?.data?.status) {
        const filteredSubscription = res.data.data?.filter(
          (item) => item?.subscription_type === "service_ticket"
        );
        setServiceTicketSubscription(filteredSubscription[0]);
      } else toast("Failed! Try again later", { type: "error" });
    });
  };

  const subscribeService = () => {
    purchaseSubscription(
      token,
      serviceTicketSubscription?.subscription_type,
      serviceTicketSubscription?.rate,
      ""
    ).then((res) => {
      setPurchaseLoading(false);
      if (res?.status) {
        if (purchaseSubscriptionMessages?.includes(res?.message?.toLowerCase()))
          return toast(res.message, { type: "info" });
        else {
          getAllAvailableSubscriptions();
          setShowPurchasePopup(false);
          toast(res.message, { type: "success" });
        }
      } else toast("Failed! Try again later", { type: "error" });
    });
  };

  const handleAssetManagementClick = () => {
    if (isSubscribed) {
      dispatch(servicePageTypeAction("PREMIUM"));
      if (
        loggedInUserDetails?.ticket_external_read_role !== "manager" &&
        loggedInUserDetails?.ticket_internal_read_role !== "manager"
      ) {
        return toast("You do not have access", { type: "info" });
      }
    } else if (serviceTicketSubscription?.rate?.length > 0) {
      if (loggedInUserDetails?.storage_subscription === "manager") {
        setPurchaseType("Asset Management & Service Ticketing ");
        setShowPurchasePopup(true);
      } else {
        toast("You do not have access", { type: "info" });
      }
    } else toast("Service not purchasable yet", { type: "info" });
  };

  const getuserData = async () => {
    try {
      const apiResponse = await getUserDetails(token);
      setAssetUserRole(apiResponse.data.data.asset_manager);
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  const getMyAssets = () => {
    setLoader();
    getAssets(token, searchKeyword, selectedClassification, selectedLocation)
      .then((res) => {
        resetLoader();
        if (res?.data?.status) {
          const assets = res.data.data || []; // Default to empty array if undefined

          // Ensure assets is an array before sorting
          setMyAssets(Array.isArray(assets) ? assets.sort(byNewestFirst) : []);
        } else {
          toast("Failed! Try again later", { type: "error" });
        }
      })
      .catch((error) => {
        resetLoader();
        console.error("Error fetching assets:", error);
        toast("Error fetching assets", { type: "error" });
      });
  };

  const getSharedAsset = () => {
    setLoader();
    getSharedAssets(token, searchKeyword).then((res) => {
      resetLoader();
      if (res?.data?.status) {
        const assets = res?.data?.data || []; // Ensure assets is an array
        setSharedAssets(assets.sort(byNewestFirst));
      } else {
        console.log("Failed! Try again later", { type: "error" });
      }
    });
  };

  const handleDelete = (id) => {
    deleteAssets(token, id)
      .then(() => {
        toast("Asset archived successfully", { type: "success" });
        getMyAssets();
        getSharedAsset();
      })
      .catch((err) => {
        resetLoader();
        console.error("Error deleting asset:", err);
        toast("Error deleting asset", { type: "error" });
      })
      .finally(() => {
        setConfirmPopup(false); // Close the confirmation popup after action
      });
  };

  const fetchClassification = () => {
    getClassificationList(token, loggedInUserDetails?.org_id).then((res) => {
      if (res?.data) {
        setClassifications(res.data);
      }
    });
  };

  const getAllLocations = () => {
    getLocationData(token, loggedInUserDetails?.org_id).then((res) => {
      if (res?.location?.length > 0) {
        setLocationList(res?.location);
      }
    });
  };

  const renderHeaders = (headers) => (
    <div className="asset-box-wrapper">
      {headers.map((header) => (
        <div key={header} className="assetm-head-row">
          {header}
        </div>
      ))}
    </div>
  );

  return (
    <>
      <div className="asset-management-parent">
        <div className="asset-management-header">
          <Headers />
        </div>
        <div className="asset-management-navigation">
          <Navigation />
        </div>
        <div className="asset-management-main">
          <h1>Asset Management</h1>
          <div className="asset-management-main-box">
            <div className="header-bar-asset">
              <div
                className="asset-search asset-management-search"
                style={{ marginBottom: assetUserRole ? "auto" : "20px" }}
              >
                <input
                  type="text"
                  placeholder="Search assets by Asset# /Asset name /Vendor Name"
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
                <SearchIcon className="search-icon" />
              </div>

              <div className="createbutton">
                {assetUserRole && (
                  <button
                    onClick={() => {
                      if (isSubscribed) navigate("/create-assets");
                      else handleAssetManagementClick();
                    }}
                    aria-label="Create a new asset"
                    style={{
                      backgroundColor: isNotSubscribed ? "#919191" : undefined,
                    }}
                  >
                    Create New
                  </button>
                )}
                {isSuperAdmin && (
                  <button
                    onClick={() => setOpenaiassestantmodel(true)}
                    aria-label="select ai assistant model"
                  >
                    AI Assistant
                  </button>
                )}
                {isSuperAdmin && (
                  <button
                    onClick={() => setNewaimodel(true)}
                    aria-label="select ai assistant model"
                  >
                    Add AI Models
                  </button>
                )}
              </div>
            </div>

            <div className="show-asset-boxes">
              <div
                className={`asset-box ${isNotSubscribed ? "grey-overlay" : ""}`}
                onClick={() => {
                  if (isNotSubscribed) {
                    handleAssetManagementClick();
                  }
                }}
              >
                {isNotSubscribed && (
                  <img
                    src={PremiumIcon}
                    alt="Premium service"
                    className="hover-image"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                    }}
                  />
                )}

                <div className="asset-box-top">
                  <p>MY ASSETS</p>
                </div>
                <div className="asset-filters">
                  <FilterSelect
                    label="Classification"
                    value={selectedClassification}
                    onChange={setSelectedClassification}
                    allLabel="All "
                    items={classifications}
                    getKey={(item) => item.id}
                    getValue={(item) => item.id}
                    getLabel={(item) => item.classification}
                  />
                  <FilterSelect
                    label="Location"
                    value={selectedLocation}
                    onChange={setSelectedLocation}
                    allLabel="All"
                    items={locationList}
                    getKey={(loc) => loc.id}
                    getValue={(loc) => loc.location}
                    getLabel={(loc) => loc.location}
                  />
                </div>

                {renderHeaders(MY_ASSETS_HEADERS)}

                <div className="asset-box-bottom">
                  {MyAssets?.length > 0 ? (
                    MyAssets.map((asset, index) => (
                      <div className="asset-content-wrapper" key={index}>
                        <div
                          className="asset-content-row"
                          style={{ color: "#4671A4", fontWeight: "bold" }}
                          onClick={() => {
                            if (isSubscribed) {
                              dispatch(assetuniqueid(asset?.unique_id));
                              navigate("/asset-details");
                            }
                          }}
                        >
                          {truncate(asset?.assetNumber)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.assetsName)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.classification_name)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.assetLocation)}
                        </div>
                        <div
                          className="asset-content-row"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {truncate(asset?.vendorName)}
                          <IconButton
                            style={{ padding: "0px", margin: "5px" }}
                            onClick={(event) => {
                              if (isSubscribed) {
                                setAnchorEl(event.currentTarget);
                                setSelectedAssetId(asset?.unique_id);
                              }
                            }}
                            className="dropdown-styling"
                          >
                            <img
                              src={options}
                              alt="Menu options"
                              style={{ height: "18px" }}
                            />
                          </IconButton>
                        </div>
                      </div>
                    ))
                  ) : (
                    <EmptyAssets />
                  )}
                </div>
              </div>

              <div className="asset-box">
                <div className="asset-box-top">
                  <p>ASSETS SHARED WITH ME</p>
                </div>
                {renderHeaders(SHARED_ASSETS_HEADERS)}
                <div className="asset-box-bottom">
                  {SharedAssets?.length > 0 ? (
                    SharedAssets.map((asset, index) => (
                      <div className="asset-content-wrapper" key={index}>
                        <div
                          className="asset-content-row"
                          style={{ color: "#4671A4", fontWeight: "bold" }}
                          onClick={() => {
                            dispatch(assetuniqueid(asset?.unique_id));
                            navigate("/asset-details", {
                              state: { isShared: true },
                            });
                          }}
                        >
                          {truncate(asset?.assetNumber)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.assetsName)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.assetLocation)}
                        </div>
                        <div className="asset-content-row">
                          {truncate(asset?.vendorName)}
                        </div>
                      </div>
                    ))
                  ) : (
                    <EmptyAssets />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader}
      {confirmPopup && (
        <RenderConfirm
          message={`Archive it?`}
          data={selectedAssetId}
          hide={setConfirmPopup}
          status={handleDelete}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        style={{ boxShadow: "none" }}
      >
        <MenuItem
          onClick={() => {
            setConfirmPopup(true);
            setAnchorEl(null);
          }}
          style={{
            boxShadow: "none",
            borderRadius: "5px",
            color: "grey",
            padding: "4px 10px",
            fontSize: "12px",
          }}
        >
          Archive
        </MenuItem>
      </Menu>
      {showPurchasePopup && (
        <PurchaseSubscription
          header={purchaseType}
          description={`This is a Premium Service. You need to purchase it with a charge of ${serviceTicketSubscription?.rate} Credits Per Month.`}
          hide={() => setShowPurchasePopup(false)}
          subscribeService={subscribeService}
          setLoading={setPurchaseLoading}
          loading={purchaseLoading}
        />
      )}
      {Openaiassestantmodel && (
        <AiAssistant onClose={() => setOpenaiassestantmodel(false)} />
      )}
      {newaimodel && <AiModel onClose={() => setNewaimodel(false)} />}
    </>
  );
};

export default AssetManagement;
